export default "__VITE_ASSET__FZfWGgkB__"